export const BENIFICIARY_STATUS = {
  CREATED: 0,
  TESTED: 1,
  VALIDATED: 2,
  ASSIGNED_FOR_DONATION: 3,
  DONATED: 4,

  FOLLOWUP_ASSIGNED: 5,
};

export const BENIFICIARY_LOG_STATUS = {
  MODIFIED: -1,
  CREATED: 0,
  TESTED: 1,
  VALIDATED: 2,
  DONATION_ASSIGNED: 3,
  DONATED: 4,
  FOLLOWUP_ASSIGNED: 5,
  FOLLOWUP_TAKEN: 6,
  FOLLOWUP_RESCHEDULED: 7,
};

export const LEVEL_OF_HEARING_LOSS = {
  NORMAL: 1,
  MINIMAL: 2,
  MILD: 3,
  MODERATE: 4,
  MODERATE_SEVERE: 5,
  SEVERE: 6,
  PROFOUND: 7,
};

export const HEARING_LOSS_COLORS = {
  [LEVEL_OF_HEARING_LOSS.NORMAL]: "#2ECC71",
  [LEVEL_OF_HEARING_LOSS.MINIMAL]: "#A2D149",
  [LEVEL_OF_HEARING_LOSS.MILD]: "#F1C40F",
  [LEVEL_OF_HEARING_LOSS.MODERATE]: "#E67E22",
  [LEVEL_OF_HEARING_LOSS.MODERATE_SEVERE]: "#D35400",
  [LEVEL_OF_HEARING_LOSS.SEVERE]: "#E74C3C",
  [LEVEL_OF_HEARING_LOSS.PROFOUND]: "#8E44AD",
};
export const FOLLOW_UP_STATUS = {
  PENDING: 1,
  FOLLOWED_UP: 2,
};
export const FOLLOW_UP_LOG_TYPE = {
  ASSIGNED: 1,
  CALL_NO_ANSWERED: 2,
  CALL_RESCHEDULED: 3,
  CALL_ANSWERED: 4,
};
export const SPEECH_STATE = {
  S1: 1,
  S2: 2,
  S3: 3,
  S4: 4,
};
export const FOLLOWUP_TYPE = {
  GENERAL: null,
  INCLUSIVE: 1,
};

export const INCLUSION_STATE = {
  I1: 1,
  I2: 2,
  I3: 3,
};
export const INCLUSION_STATE_NAME = {
  I1: "(I1) Domestic Activity",
  I2: "(I2) Taking Initiative",
  I3: "(I3) Indipendent",
};
export const HEARING_STATE = {
  H1: 1,
  H2: 2,
  H3: 3,
  H4: 4,
};
export const TYPE_OF_HEARING_LOSS = {
  CONDUCTIVE: 1,
  SN: 2,
  MIXED: 3,
};
export const HAS_HEARING_LOSS = {
  YES: 1,
  NO: 2,
};
export const TYPE_OF_HEARING_LOSS_LIST = [
  {
    _id: 1,
    label: "Conductive",
  },
  {
    _id: 2,
    label: "SN",
  },
  {
    _id: 3,
    label: "Mixed",
  },
];
export const SEVEARITY_OF_LOSS = {
  NORMAL: 6,
  MILD: 1,
  MODERATE: 2,
  SEVERE: 3,
  PROFOUND: 4,
  MODERATE_TO_SEVERE: 5,
};
export const WAY_OF_CONFIRMATION = {
  HAND: 1,
  EYE_CONTACT: 2,
  VERBAL_CONFIRMATION: 3,
  OTHER: 4,
};

export const CAMP_STATUS = {
  OPEN: 1,
  CLOSED: 2,
};
